<div class="error-card" [@errorState]="!!message">
    <div class="message">{{message}}</div>
</div>
